module.exports = __webpack_public_path__ + "_assets/img/chevron.e41bb48b.svg";